import ScheduleTimes from "src/components/ScheduleTimes/ScheduleTimes";
import { IScheduleTimesCallback } from "src/models";

export default {
    scheduleTimesComponent: null,

    dispose() {
        if (this.scheduleTimesComponent) {
            this.scheduleTimesComponent.dispose();
        }
        this.scheduleTimesComponent = null;
    },

    show(callback: IScheduleTimesCallback) {
        if (!this.scheduleTimesComponent) {
            this.scheduleTimesComponent = new ScheduleTimes({
                source: '<x-schedule-times></x-schedule-times>'
            });
            this.scheduleTimesComponent.attach(document.body);
        }
        this.scheduleTimesComponent.show(callback);
    }
};